import zaguan from '../assets/projects_images/zaguan-tb.png';
import hangman from '../assets/projects_images/hangman-tb.png';
import landing from '../assets/projects_images/landing-tb.png';
import moone from '../assets/projects_images/moone-tb.png';
import billion from '../assets/projects_images/billion-tb.png';
import covid from '../assets/projects_images/covid-tb.png';
import plaindar from '../assets/projects_images/plaindar-tb.png';
import hotely from '../assets/projects_images/hotely-tb.png';
import pwa from '../assets/projects_images/pwa-tb.png';
import webnine from '../assets/projects_images/webnine-tb.png';
import travel from '../assets/projects_images/travel-tb.png';

const data_projects = [
  {
    name: 'Bar El-Zaguan',
    image: zaguan,
    deployed_url: 'https://elzaguanbar.netlify.app/',
    type: 'react',
    category: ['react'],
  },

  {
    name: 'Hangman Game',
    image: hangman,
    deployed_url: 'https://donthangplease.netlify.app/',
    type: 'js',
    category: ['js'],
  },

  {
    name: 'StartUp Landing Page',
    image: landing,
    deployed_url: 'https://startuplandingpage.netlify.app/',
    type: 'react',
    category: ['react'],
  },
  {
    name: 'PWeatherApp',
    image: pwa,
    deployed_url: 'https://pweatherapp.netlify.app/',
    type: 'pwa',
    category: ['react', 'pwa'],
  },
  {
    name: 'Moone to-do App',
    image: moone,
    deployed_url: 'https://moone-to-do.netlify.app/',
    type: 'react',
    category: ['react', 'material'],
  },
  {
    name: 'Plaindar',
    image: plaindar,
    deployed_url: 'https://plaindar.netlify.app/',
    type: 'js',
    category: ['js'],
  },
  {
    name: 'Billion Bank',
    image: billion,
    deployed_url: 'https://billionbank.netlify.app/',
    type: 'react',
    category: ['react'],
  },

  {
    name: 'COVID 19 Tracker',
    image: covid,
    deployed_url: 'https://covid19worldstatus.netlify.app/',
    type: 'react',
    category: ['react'],
  },
  {
    name: 'Hotely',
    image: hotely,
    deployed_url: 'https://hotely-site.netlify.app/',
    type: 'react',
    category: ['react'],
  },

  {
    name: 'TRAVL',
    image: travel,
    deployed_url: 'https://travl-online.netlify.app/',
    type: 'react',
    category: ['react'],
  },
  {
    name: 'Web nine',
    image: webnine,
    deployed_url: 'https://webnine.netlify.app/',
    type: 'react',
    category: ['react'],
  },
];

export default data_projects;
